module.exports = __webpack_public_path__ + "static/media/payment-img.64c6910e.svg";